import { render, staticRenderFns } from "./room_aside_form.vue?vue&type=template&id=572ef2bc&"
import script from "./room_aside_form.vue?vue&type=script&lang=js&"
export * from "./room_aside_form.vue?vue&type=script&lang=js&"
import style0 from "./room_aside_form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports